import { Tooltip } from '@mui/material';

const Flower = ({ flowerId, color, size, isDynamic = false, parentBranchNum = 0, widthScale = 1, utterance }) => {
  const sizeStyle = size
    ? { width: `${size}px`, height: `${size}px`, position: 'relative' }
    : {};

  const flowerElement = (
    <div
      id={flowerId}
      style={{ display: 'block', ...sizeStyle }}
      className={`flower petal5 flower2 ${color}`}
      aria-hidden="true"
    >
      <div style={{ display: 'block' }} className="petal">
        <div style={{ display: 'block' }} className="petal">
          <div style={{ display: 'block' }} className="petal"></div>
        </div>
      </div>
    </div>
  );

  const utterances = Array.isArray(utterance) ? utterance : (utterance ? [utterance] : []);

  if (utterances.length === 0) {
    return flowerElement;
  }

  const tooltipContent = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      {utterances.map((text, i) => (
        <div
          key={i}
          style={{
            paddingBottom: i < utterances.length - 1 ? '6px' : 0,
            borderBottom: i < utterances.length - 1 ? '1px solid rgba(255,255,255,0.2)' : 'none',
          }}
        >
          {text}
        </div>
      ))}
    </div>
  );

  return (
    <Tooltip
      title={tooltipContent}
      arrow
      placement="top"
      enterDelay={200}
      leaveDelay={100}
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: '280px',
            fontSize: '0.8rem',
            lineHeight: 1.4,
            padding: '0.5rem 0.75rem',
          },
        },
      }}
    >
      {flowerElement}
    </Tooltip>
  );
};

export default Flower;